import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { ApiService } from 'services/api.service';

@Injectable()
export class FacilityService extends ApiService {

  async getGlobalEmbassies(country: string) {
    const data = {
      country,
      origin: 'United States',
    };

    try {
      const url = '/location/category/global-embassy/bycountry';
      const response: any = await this.postRequest(url, data);
      const embassies = response.data && response.data.facilities;

      return embassies;
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/facility.service.ts